import { useState } from "react";

const C = {
  bg: "#F5F6FA", surface: "#FFFFFF", card: "#FFFFFF", cardBorder: "#E2E5EC",
  hover: "#F0F1F5", accent: "#D23A3B", accentSoft: "rgba(210,58,59,0.08)",
  green: "#16A34A", greenSoft: "rgba(22,163,74,0.08)",
  red: "#DC2626", redSoft: "rgba(220,38,38,0.08)",
  orange: "#D97706", orangeSoft: "rgba(217,119,6,0.08)",
  purple: "#D23A3B", purpleSoft: "rgba(210,58,59,0.08)",
  t1: "#1A1D2E", t2: "#5A6178", t3: "#9CA3B8", divider: "#E8EAF0",
  shadow: "0 1px 3px rgba(0,0,0,0.06)",
};

// Material Symbols Rounded helper
const Icon = ({ name, size = 18, color, style = {} }: any) => (
  <span
    className="material-symbols-rounded"
    style={{ fontSize: size, lineHeight: 1, color: color || "inherit", userSelect: "none", flexShrink: 0, ...style }}
  >
    {name}
  </span>
);

const Phone = ({ children, label }: any) => (
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
    <div style={{
      width: 375, height: 812, background: C.bg, borderRadius: 40, overflow: "hidden",
      border: "3px solid #D1D5DB", position: "relative", boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
      display: "flex", flexDirection: "column",
    }}>
      <div style={{ height: 44, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 28px", flexShrink: 0 }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: C.t1 }}>9:41</span>
        <div style={{ width: 125, height: 30, background: C.bg, borderRadius: "0 0 16px 16px", position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)" }} />
        <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
          <span style={{ fontSize: 11, color: C.t2 }}>5G</span>
          <Icon name="battery_full" size={16} color={C.t2} />
        </div>
      </div>
      {children}
    </div>
    <span style={{ fontSize: 13, fontWeight: 600, color: "#5A6178", letterSpacing: 0.5 }}>{label}</span>
  </div>
);

const NAV = [
  { icon: "flash_on",     label: "Snapshot"  },
  { icon: "bar_chart",    label: "Reports"   },
  { icon: "auto_awesome", label: "Brisque AI" },
  { icon: "chat_bubble",  label: "Support"   },
];

const BottomNav = ({ active }: any) => (
  <div style={{ height: 72, background: C.surface, borderTop: `1px solid ${C.divider}`, display: "flex", justifyContent: "space-around", alignItems: "center", flexShrink: 0, paddingBottom: 8 }}>
    {NAV.map((item, i) => (
      <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3, padding: "4px 14px" }}>
        <Icon name={item.icon} size={22} color={active === i ? C.accent : C.t3} style={{ opacity: active === i ? 1 : 0.45 }} />
        <span style={{ fontSize: 9.5, fontWeight: active === i ? 700 : 400, color: active === i ? C.accent : C.t3 }}>{item.label}</span>
        {active === i && <div style={{ width: 4, height: 4, borderRadius: "50%", background: C.accent, boxShadow: `0 0 8px ${C.accent}44`, marginTop: -1 }} />}
      </div>
    ))}
  </div>
);

const Arrow = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" style={{ position: "absolute", top: 6, right: 6, opacity: 0.45 }}>
    <path d="M3.5 2L7 5L3.5 8" fill="none" stroke={C.accent} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DatePicker = ({ compact }: any) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: compact ? 8 : 12, marginBottom: compact ? 10 : 0 }}>
    <div style={{ width: 26, height: 26, borderRadius: 7, background: C.hover, border: `1px solid ${C.divider}`, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
      <Icon name="chevron_left" size={17} color={C.t2} />
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 8, background: C.surface, border: `1px solid ${C.divider}`, cursor: "pointer" }}>
      <Icon name="calendar_today" size={13} color={C.t3} />
      <span style={{ fontSize: 12, fontWeight: 600, color: C.t1 }}>Today</span>
      <span style={{ fontSize: 11, color: C.t3 }}>Mar 2, 2026</span>
    </div>
    <div style={{ width: 26, height: 26, borderRadius: 7, background: C.hover, border: `1px solid ${C.divider}`, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", opacity: 0.3 }}>
      <Icon name="chevron_right" size={17} color={C.t3} />
    </div>
  </div>
);

const OutletDropdown = () => (
  <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "5px 10px", borderRadius: 8, background: C.surface, border: `1px solid ${C.divider}`, cursor: "pointer" }}>
    <Icon name="location_on" size={14} color={C.accent} />
    <span style={{ fontSize: 11, fontWeight: 600, color: C.t1 }}>Downtown Chicago</span>
    <Icon name="expand_more" size={14} color={C.t3} />
  </div>
);

const DrillHeader = ({ title, sub }: any) => (
  <div style={{ padding: "8px 20px 6px", flexShrink: 0 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div style={{ width: 28, height: 28, borderRadius: 8, background: C.hover, border: `1px solid ${C.divider}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon name="chevron_left" size={18} color={C.t2} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 11, color: C.t3 }}>Snapshot ›</div>
        <div style={{ fontSize: 18, fontWeight: 700, color: C.t1 }}>{title}</div>
      </div>
    </div>
    {sub && <div style={{ fontSize: 10, color: C.t3, marginLeft: 36, marginTop: 1 }}>{sub}</div>}
    <div style={{ marginTop: 8 }}><DatePicker compact /></div>
  </div>
);

const KPI = ({ label, value, delta, up, drill }: any) => (
  <div style={{ background: C.card, border: `1px solid ${drill ? C.accent + "33" : C.cardBorder}`, borderRadius: 12, padding: "12px 10px", textAlign: "center", cursor: drill ? "pointer" : "default", position: "relative", boxShadow: C.shadow }}>
    {drill && <Arrow />}
    <div style={{ fontSize: 8, color: C.t3, textTransform: "uppercase", letterSpacing: 0.3 }}>{label}</div>
    <div style={{ fontSize: 18, fontWeight: 700, color: C.t1, marginTop: 4 }}>{value}</div>
    {delta && <div style={{ fontSize: 9, fontWeight: 600, color: up ? C.green : C.red, marginTop: 3 }}>{up ? "↑" : "↓"} {delta}</div>}
  </div>
);

const StatKPI = ({ label, value, drill }: any) => (
  <div style={{ background: C.card, border: `1px solid ${drill ? C.accent + "33" : C.cardBorder}`, borderRadius: 10, padding: "10px 10px", textAlign: "center", cursor: drill ? "pointer" : "default", position: "relative", boxShadow: C.shadow }}>
    {drill && <Arrow />}
    <div style={{ fontSize: 8, color: C.t3, textTransform: "uppercase", letterSpacing: 0.3 }}>{label}</div>
    <div style={{ fontSize: 18, fontWeight: 700, color: C.t1, marginTop: 3 }}>{value}</div>
  </div>
);

const VertBarChart = ({ data, labels, color, prefix, max: maxOverride }: any) => {
  const max = maxOverride || Math.max(...data);
  return (
    <div style={{ display: "flex", alignItems: "flex-end", gap: 2, height: 100, paddingBottom: 20, position: "relative" }}>
      <div style={{ position: "absolute", left: 0, top: 0, bottom: 20, display: "flex", flexDirection: "column", justifyContent: "space-between", width: 28 }}>
        <span style={{ fontSize: 8, color: C.t3 }}>{prefix}{max}</span>
        <span style={{ fontSize: 8, color: C.t3 }}>{prefix}{Math.round(max / 2)}</span>
        <span style={{ fontSize: 8, color: C.t3 }}>{prefix}0</span>
      </div>
      <div style={{ position: "absolute", left: 30, right: 0, top: 0, bottom: 20 }}>
        {[0, 0.5, 1].map((t, i) => (
          <div key={i} style={{ position: "absolute", left: 0, right: 0, top: `${t * 100}%`, height: 1, background: C.divider, opacity: 0.5 }} />
        ))}
      </div>
      <div style={{ display: "flex", alignItems: "flex-end", gap: 2, flex: 1, marginLeft: 30, height: 80 }}>
        {data.map((d, i) => {
          const isPeak = d === Math.max(...data);
          return (
            <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
              <div style={{ width: "100%", maxWidth: 18, height: `${(d / max) * 100}%`, minHeight: 2, borderRadius: "3px 3px 0 0", background: isPeak ? color : `${color}66` }} />
              <span style={{ fontSize: 7, color: isPeak ? C.t1 : C.t3, fontWeight: isPeak ? 700 : 400 }}>{labels[i]}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// =========== SNAPSHOT ===========
const SnapshotScreen = () => (
  <Phone label="SNAPSHOT">
    <div style={{ padding: "8px 20px 0", flexShrink: 0 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: C.t1 }}>Snapshot</div>
        <div style={{ width: 30, height: 30, borderRadius: 8, background: `linear-gradient(135deg, ${C.accent}, #E86B6B)`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, color: "#fff" }}>JD</div>
      </div>
      <div style={{ marginTop: 6 }}><OutletDropdown /></div>
      <div style={{ marginTop: 8 }}><DatePicker /></div>
    </div>
    <div style={{ flex: 1, overflowY: "auto", padding: "8px 16px 16px" }}>
      <div style={{ background: `linear-gradient(135deg, ${C.accent}0D, ${C.purple}0A)`, border: `1px solid ${C.accent}22`, borderRadius: 16, padding: "16px 18px", marginBottom: 10, position: "relative", overflow: "hidden", cursor: "pointer", boxShadow: C.shadow }}>
        <Arrow />
        <div style={{ position: "absolute", top: -30, right: -30, width: 100, height: 100, borderRadius: "50%", background: C.accentSoft, filter: "blur(30px)" }} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <div style={{ fontSize: 10, color: C.t2, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Net Sales</div>
            <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
              <span style={{ fontSize: 34, fontWeight: 700, color: C.t1, letterSpacing: -1 }}>$5,928</span>
              <span style={{ fontSize: 12, fontWeight: 600, color: C.green }}>↑ 11.8%</span>
            </div>
            <div style={{ fontSize: 10, color: C.t3, marginTop: 3 }}>vs yesterday $5,302</div>
          </div>
          <div style={{ textAlign: "right", marginTop: 4 }}>
            <div style={{ marginBottom: 6, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6 }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 -960 960 960" fill={C.t3}>
                <path d="M320-200h60v-270q26-8 43-28.5t17-49.5v-152q0-8-6-14t-14-6q-8 0-14 6t-6 14v100h-30v-100q0-8-6-14t-14-6q-8 0-14 6t-6 14v100h-30v-100q0-8-6-14t-14-6q-8 0-14 6t-6 14v152q0 29 17 49.5t43 28.5v270Zm240 0h60v-254q33-16 51.5-51t18.5-82q0-57-28.5-95T590-720q-43 0-71.5 38T490-587q0 47 18.5 82t51.5 51v254ZM160-80q-33 0-56.5-23.5T80-160v-640q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v640q0 33-23.5 56.5T800-80H160Zm0-80h640v-640H160v640Zm0 0v-640 640Z"/>
              </svg>
              <div style={{ fontSize: 16, fontWeight: 700, color: C.t1 }}>$2,608</div>
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6 }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 -960 960 960" fill={C.t3}>
                <path d="M120-640v-200h280v200H120Zm80-80h120v-40H200v40Zm-5 485q-35-35-35-85H80v-120q0-66 47-113t113-47h160v200h140l140-174v-106H560v-80h120q33 0 56.5 23.5T760-680v134L580-320H400q0 50-35 85t-85 35q-50 0-85-35Zm113.5-56.5Q320-303 320-320h-80q0 17 11.5 28.5T280-280q17 0 28.5-11.5ZM675-235q-35-35-35-85t35-85q35-35 85-35t85 35q35 35 35 85t-35 85q-35 35-85 35t-85-35Zm113.5-56.5Q800-303 800-320t-11.5-28.5Q777-360 760-360t-28.5 11.5Q720-337 720-320t11.5 28.5Q743-280 760-280t28.5-11.5ZM160-400h160v-120h-80q-33 0-56.5 23.5T160-440v40Zm160-320v-40 40Zm0 320Z"/>
              </svg>
              <div style={{ fontSize: 16, fontWeight: 700, color: C.t1 }}>$1,842</div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 8 }}>
        <KPI label="Orders" value="287" delta="+8.3%" up={true} drill={true} />
        <KPI label="Avg Order" value="$23.85" delta="-2.1%" up={false} drill={false} />
        <KPI label="Cancelled" value="$142" delta="+22%" up={false} drill={true} />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 8 }}>
        <StatKPI label="Active Staff" value="6" drill={true} />
        <StatKPI label="Sales/Hr" value="$392" drill={false} />
        <StatKPI label="Voids" value="3" drill={true} />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 8 }}>
        <StatKPI label="Tips" value="$847" drill={true} />
        <StatKPI label="Taxes" value="$456" drill={false} />
        <StatKPI label="Discounts" value="$320" drill={false} />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 10 }}>
        <StatKPI label="Check-Ins" value="84" drill={false} />
        <StatKPI label="Avg Wait" value="12m" drill={false} />
        <StatKPI label="Guests" value="218" drill={false} />
      </div>
      <div style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 12, padding: "12px 14px", boxShadow: C.shadow }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: C.t1, marginBottom: 8 }}>Top 3 Items Today</div>
        {[{ name: "Classic Burger", qty: 42, rev: "$630" }, { name: "Margherita Pizza", qty: 38, rev: "$570" }, { name: "Chicken Wings", qty: 31, rev: "$465" }].map((item, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "5px 0", borderBottom: i < 2 ? `1px solid ${C.divider}` : "none" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ width: 18, height: 18, borderRadius: 5, background: i === 0 ? C.accentSoft : C.hover, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 700, color: i === 0 ? C.accent : C.t3 }}>{i + 1}</span>
              <span style={{ fontSize: 11, color: C.t1 }}>{item.name}</span>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <span style={{ fontSize: 10, color: C.t3 }}>{item.qty} qty</span>
              <span style={{ fontSize: 11, fontWeight: 600, color: C.t1 }}>{item.rev}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
    <BottomNav active={0} />
  </Phone>
);

// =========== DRILL 1: NET SALES ===========
const DrillNetSales = () => {
  const hours = ["6a","7a","8a","9a","10a","11a","12p","1p","2p","3p","4p","5p","6p","7p","8p","9p"];
  const data = [82,145,210,380,520,680,890,760,540,420,480,620,840,920,780,460];
  return (
    <Phone label="DRILL: NET SALES">
      <DrillHeader title="Net Sales" sub="$5,928 total" />
      <div style={{ flex: 1, overflowY: "auto", padding: "0 16px 16px" }}>
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          {[{ l: "Net Sales", v: "$5,928" }, { l: "Peak Hour", v: "7 PM" }, { l: "Avg/Hour", v: "$494" }].map((k, i) => (
            <div key={i} style={{ flex: 1, background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 10, padding: "8px 6px", textAlign: "center", boxShadow: C.shadow }}>
              <div style={{ fontSize: 7, color: C.t3, textTransform: "uppercase" }}>{k.l}</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: i === 1 ? C.accent : C.t1, marginTop: 2 }}>{k.v}</div>
            </div>
          ))}
        </div>
        <div style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 14, padding: "14px 12px", marginBottom: 12, boxShadow: C.shadow }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: C.t1, marginBottom: 8 }}>Hourly Revenue</div>
          <VertBarChart data={data} labels={hours} color={C.accent} prefix="$" />
        </div>
        <div style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 14, padding: 14, boxShadow: C.shadow }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: C.t1, marginBottom: 10 }}>By Staff</div>
          {[{ n: "Sarah Chen", s: "$1,420", p: 24 }, { n: "Mike Rodriguez", s: "$1,185", p: 20 }, { n: "Emily Park", s: "$1,068", p: 18 }, { n: "James Wilson", s: "$890", p: 15 }, { n: "Aisha Patel", s: "$742", p: 13 }, { n: "David Kim", s: "$623", p: 10 }].map((s, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 5 }}>
              <span style={{ width: 14, fontSize: 9, color: C.t3, textAlign: "right" }}>{i + 1}</span>
              <span style={{ flex: 1, fontSize: 11, color: C.t1 }}>{s.n}</span>
              <span style={{ fontSize: 10, color: C.t3, width: 28 }}>{s.p}%</span>
              <span style={{ fontSize: 11, fontWeight: 600, color: C.t1, width: 48, textAlign: "right" }}>{s.s}</span>
            </div>
          ))}
        </div>
      </div>
      <BottomNav active={0} />
    </Phone>
  );
};

// =========== DRILL 2: ORDERS ===========
const DrillOrders = () => {
  const hours = ["6a","7a","8a","9a","10a","11a","12p","1p","2p","3p","4p","5p","6p","7p","8p","9p"];
  const data = [4,8,12,18,24,32,42,36,26,20,22,28,38,44,36,22];
  return (
    <Phone label="DRILL: ORDERS">
      <DrillHeader title="Orders" sub="287 total" />
      <div style={{ flex: 1, overflowY: "auto", padding: "0 16px 16px" }}>
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          {[{ l: "Total", v: "287" }, { l: "Peak Hour", v: "7 PM" }, { l: "Avg/Hour", v: "18" }].map((k, i) => (
            <div key={i} style={{ flex: 1, background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 10, padding: "8px 6px", textAlign: "center", boxShadow: C.shadow }}>
              <div style={{ fontSize: 7, color: C.t3, textTransform: "uppercase" }}>{k.l}</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: i === 1 ? C.accent : C.t1, marginTop: 2 }}>{k.v}</div>
            </div>
          ))}
        </div>
        <div style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 14, padding: "14px 12px", marginBottom: 12, boxShadow: C.shadow }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: C.t1, marginBottom: 8 }}>Hourly Orders</div>
          <VertBarChart data={data} labels={hours} color={C.green} prefix="" />
        </div>
        <div style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 14, padding: 14, boxShadow: C.shadow }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: C.t1, marginBottom: 10 }}>By Channel</div>
          {[{ c: "Dine-In", n: 124, p: 43 }, { c: "Delivery (Maghil)", n: 68, p: 24 }, { c: "DoorDash", n: 42, p: 15 }, { c: "Uber Eats", n: 31, p: 11 }, { c: "In-Store Pickup", n: 22, p: 7 }].map((ch, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "7px 0", borderBottom: i < 4 ? `1px solid ${C.divider}` : "none" }}>
              <span style={{ fontSize: 12, color: C.t1 }}>{ch.c}</span>
              <div style={{ display: "flex", gap: 10 }}>
                <span style={{ fontSize: 10, color: C.t3 }}>{ch.p}%</span>
                <span style={{ fontSize: 12, fontWeight: 600, color: C.t1, width: 28, textAlign: "right" }}>{ch.n}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <BottomNav active={0} />
    </Phone>
  );
};

// =========== DRILL 3: CANCELLED ===========
const DrillCancelled = () => (
  <Phone label="DRILL: CANCELLED">
    <DrillHeader title="Cancelled Orders" sub="7 orders · $142 total" />
    <div style={{ flex: 1, overflowY: "auto", padding: "0 16px 16px" }}>
      <div style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 14, padding: 14, marginBottom: 12, boxShadow: C.shadow }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: C.t1, marginBottom: 10 }}>Cancel Reasons</div>
        {[{ r: "Customer changed mind", c: 3, p: 43 }, { r: "Long wait time", c: 2, p: 28 }, { r: "Item unavailable", c: 1, p: 14 }, { r: "Duplicate order", c: 1, p: 14 }].map((r, i) => (
          <div key={i} style={{ marginBottom: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
              <span style={{ fontSize: 11, color: C.t2 }}>{r.r}</span>
              <span style={{ fontSize: 11, fontWeight: 600, color: C.t1 }}>{r.c}x</span>
            </div>
            <div style={{ height: 5, background: C.hover, borderRadius: 3, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${r.p}%`, background: C.red, borderRadius: 3, opacity: 0.6 }} />
            </div>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 12, fontWeight: 600, color: C.t1, marginBottom: 8 }}>Order Log</div>
      {[
        { id: "#4821", time: "2:34 PM", amt: "$28.50", reason: "Customer changed mind", staff: "Mike Rodriguez", ch: "Dine-In" },
        { id: "#4798", time: "1:12 PM", amt: "$22.00", reason: "Long wait time", staff: "James Wilson", ch: "Dine-In" },
        { id: "#4776", time: "12:45 PM", amt: "$18.75", reason: "Customer changed mind", staff: "Emily Park", ch: "Delivery" },
        { id: "#4752", time: "11:30 AM", amt: "$24.00", reason: "Item unavailable", staff: "Sarah Chen", ch: "DoorDash" },
        { id: "#4731", time: "10:58 AM", amt: "$16.50", reason: "Long wait time", staff: "Aisha Patel", ch: "Dine-In" },
        { id: "#4718", time: "10:15 AM", amt: "$19.25", reason: "Customer changed mind", staff: "Mike Rodriguez", ch: "Uber Eats" },
        { id: "#4695", time: "9:20 AM", amt: "$13.00", reason: "Duplicate order", staff: "System", ch: "DoorDash" },
      ].map((o, i) => (
        <div key={i} style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 10, padding: "10px 12px", marginBottom: 5, boxShadow: C.shadow }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: C.t1 }}>{o.id}</span>
              <span style={{ fontSize: 10, color: C.t3 }}>{o.time}</span>
            </div>
            <span style={{ fontSize: 12, fontWeight: 600, color: C.red }}>{o.amt}</span>
          </div>
          <div style={{ fontSize: 12, fontWeight: 600, color: C.accent, marginBottom: 2 }}>{o.staff}</div>
          <div style={{ fontSize: 10, color: C.t2, marginBottom: 3 }}>{o.reason}</div>
          <span style={{ fontSize: 9, color: C.t3, padding: "2px 6px", borderRadius: 4, background: C.hover }}>{o.ch}</span>
        </div>
      ))}
    </div>
    <BottomNav active={0} />
  </Phone>
);

// =========== DRILL 4: ACTIVE STAFF ===========
const DrillStaff = () => (
  <Phone label="DRILL: ACTIVE STAFF">
    <DrillHeader title="Active Staff" sub="6 active · 2 on break" />
    <div style={{ flex: 1, overflowY: "auto", padding: "0 16px 16px" }}>
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        {[{ l: "Active", v: "6", c: C.green }, { l: "On Break", v: "2", c: C.orange }, { l: "Total Hrs", v: "52h", c: C.t1 }].map((k, i) => (
          <div key={i} style={{ flex: 1, background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 10, padding: "8px 6px", textAlign: "center", boxShadow: C.shadow }}>
            <div style={{ fontSize: 7, color: C.t3, textTransform: "uppercase" }}>{k.l}</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: k.c, marginTop: 2 }}>{k.v}</div>
          </div>
        ))}
      </div>
      {[
        { name: "Sarah Chen", role: "Server", clockIn: "6:00 AM", hours: "9.7h", status: "active", sales: "$1,420" },
        { name: "Mike Rodriguez", role: "Server", clockIn: "6:30 AM", hours: "9.2h", status: "active", sales: "$1,185" },
        { name: "Emily Park", role: "Server", clockIn: "7:00 AM", hours: "8.7h", status: "break", sales: "$1,068" },
        { name: "James Wilson", role: "Bartender", clockIn: "10:00 AM", hours: "5.7h", status: "active", sales: "$890" },
        { name: "Aisha Patel", role: "Server", clockIn: "11:00 AM", hours: "4.7h", status: "active", sales: "$742" },
        { name: "David Kim", role: "Cashier", clockIn: "11:30 AM", hours: "4.2h", status: "break", sales: "$623" },
        { name: "Lisa Thompson", role: "Server", clockIn: "2:00 PM", hours: "1.7h", status: "active", sales: "$340" },
        { name: "Carlos Garcia", role: "Server", clockIn: "3:00 PM", hours: "0.7h", status: "active", sales: "$180" },
      ].map((s, i) => (
        <div key={i} style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 10, padding: "12px 12px", marginBottom: 5, boxShadow: C.shadow }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ width: 8, height: 8, borderRadius: "50%", background: s.status === "active" ? C.green : C.orange }} />
              <span style={{ fontSize: 13, fontWeight: 600, color: C.t1 }}>{s.name}</span>
            </div>
            <span style={{ fontSize: 12, fontWeight: 600, color: C.t1 }}>{s.sales}</span>
          </div>
          <div style={{ display: "flex", gap: 5, marginLeft: 16 }}>
            <span style={{ fontSize: 9, color: C.t3, padding: "2px 6px", borderRadius: 4, background: C.hover }}>{s.role}</span>
            <span style={{ fontSize: 9, color: C.t3, padding: "2px 6px", borderRadius: 4, background: C.hover }}>In: {s.clockIn}</span>
            <span style={{ fontSize: 9, color: C.t3, padding: "2px 6px", borderRadius: 4, background: C.hover }}>{s.hours}</span>
            <span style={{ fontSize: 9, fontWeight: 600, padding: "2px 6px", borderRadius: 4, color: s.status === "active" ? C.green : C.orange, background: s.status === "active" ? C.greenSoft : C.orangeSoft }}>{s.status === "active" ? "Active" : "Break"}</span>
          </div>
        </div>
      ))}
    </div>
    <BottomNav active={0} />
  </Phone>
);

// =========== DRILL 5: VOIDS ===========
const DrillVoids = () => (
  <Phone label="DRILL: VOIDS">
    <DrillHeader title="Voids" sub="3 voids · $86 total" />
    <div style={{ flex: 1, overflowY: "auto", padding: "0 16px 16px" }}>
      <div style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 14, padding: 14, marginBottom: 12, boxShadow: C.shadow }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: C.t1, marginBottom: 10 }}>Void Reasons</div>
        {[{ r: "Customer changed mind", c: 1, p: 33 }, { r: "Wrong item entered", c: 1, p: 33 }, { r: "Kitchen error", c: 1, p: 33 }].map((r, i) => (
          <div key={i} style={{ marginBottom: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
              <span style={{ fontSize: 11, color: C.t2 }}>{r.r}</span>
              <span style={{ fontSize: 11, fontWeight: 600, color: C.t1 }}>{r.c}x</span>
            </div>
            <div style={{ height: 5, background: C.hover, borderRadius: 3, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${r.p}%`, background: C.orange, borderRadius: 3, opacity: 0.6 }} />
            </div>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 12, fontWeight: 600, color: C.t1, marginBottom: 8 }}>Void Log</div>
      {[
        { item: "Margherita Pizza", amount: "$15.00", time: "1:42 PM", reason: "Customer changed mind", staff: "James Wilson" },
        { item: "Caesar Salad (x2)", amount: "$22.00", time: "12:18 PM", reason: "Wrong item entered", staff: "James Wilson" },
        { item: "Fish Tacos", amount: "$14.00", time: "11:05 AM", reason: "Kitchen error", staff: "Mike Rodriguez" },
      ].map((v, i) => (
        <div key={i} style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 10, padding: "12px 12px", marginBottom: 5, boxShadow: C.shadow }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: C.t1 }}>{v.item}</span>
            <span style={{ fontSize: 12, fontWeight: 600, color: C.orange }}>{v.amount}</span>
          </div>
          <div style={{ fontSize: 12, fontWeight: 600, color: C.accent, marginBottom: 2 }}>{v.staff}</div>
          <div style={{ fontSize: 10, color: C.t2, marginBottom: 3 }}>{v.reason}</div>
          <span style={{ fontSize: 9, color: C.t3, padding: "2px 6px", borderRadius: 4, background: C.hover }}>{v.time}</span>
        </div>
      ))}
      <div style={{ background: C.redSoft, border: `1px solid ${C.red}33`, borderRadius: 12, padding: "12px 14px", marginTop: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
          <Icon name="warning" size={14} color={C.red} />
          <span style={{ fontSize: 11, fontWeight: 600, color: C.red }}>Attention</span>
        </div>
        <div style={{ fontSize: 11, color: C.t2, lineHeight: 1.5 }}><strong style={{ color: C.t1 }}>James Wilson</strong> has 2 of 3 voids today ($37 total). Consider reviewing with manager.</div>
      </div>
    </div>
    <BottomNav active={0} />
  </Phone>
);

// =========== DRILL 6: TIPS ===========
const DrillTips = () => (
  <Phone label="DRILL: TIPS">
    <DrillHeader title="Tips" sub="$847 total" />
    <div style={{ flex: 1, overflowY: "auto", padding: "0 16px 16px" }}>
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        {[{ l: "Total Tips", v: "$847" }, { l: "Avg/Order", v: "$2.95" }, { l: "Tip Rate", v: "14.3%" }].map((k, i) => (
          <div key={i} style={{ flex: 1, background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 10, padding: "8px 6px", textAlign: "center", boxShadow: C.shadow }}>
            <div style={{ fontSize: 7, color: C.t3, textTransform: "uppercase" }}>{k.l}</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: C.t1, marginTop: 2 }}>{k.v}</div>
          </div>
        ))}
      </div>
      <div style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 14, padding: 14, marginBottom: 12, boxShadow: C.shadow }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: C.t1, marginBottom: 10 }}>Tips by Staff</div>
        {[
          { n: "Sarah Chen", tips: "$218", rate: "18.2%", val: 218 },
          { n: "Mike Rodriguez", tips: "$185", rate: "15.6%", val: 185 },
          { n: "Emily Park", tips: "$142", rate: "13.3%", val: 142 },
          { n: "James Wilson", tips: "$108", rate: "12.1%", val: 108 },
          { n: "Aisha Patel", tips: "$92", rate: "13.4%", val: 92 },
          { n: "David Kim", tips: "$58", rate: "9.3%", val: 58 },
          { n: "Lisa Thompson", tips: "$28", rate: "14.0%", val: 28 },
          { n: "Carlos Garcia", tips: "$16", rate: "12.3%", val: 16 },
        ].map((s, i) => (
          <div key={i} style={{ marginBottom: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
              <span style={{ fontSize: 11, color: C.t1, fontWeight: 500 }}>{s.n}</span>
              <div style={{ display: "flex", gap: 8 }}>
                <span style={{ fontSize: 10, color: C.t3 }}>{s.rate}</span>
                <span style={{ fontSize: 11, fontWeight: 600, color: C.t1, width: 38, textAlign: "right" }}>{s.tips}</span>
              </div>
            </div>
            <div style={{ height: 5, background: C.hover, borderRadius: 3, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${(s.val / 218) * 100}%`, background: C.green, borderRadius: 3, opacity: 0.7 }} />
            </div>
          </div>
        ))}
      </div>
      <div style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 14, padding: 14, boxShadow: C.shadow }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: C.t1, marginBottom: 10 }}>Tips by Channel</div>
        {[{ c: "Dine-In", v: "$542", p: 64 }, { c: "Delivery", v: "$185", p: 22 }, { c: "Pickup", v: "$78", p: 9 }, { c: "3rd Party", v: "$42", p: 5 }].map((ch, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "6px 0", borderBottom: i < 3 ? `1px solid ${C.divider}` : "none" }}>
            <span style={{ fontSize: 12, color: C.t1 }}>{ch.c}</span>
            <div style={{ display: "flex", gap: 10 }}>
              <span style={{ fontSize: 10, color: C.t3 }}>{ch.p}%</span>
              <span style={{ fontSize: 12, fontWeight: 600, color: C.t1, width: 40, textAlign: "right" }}>{ch.v}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
    <BottomNav active={0} />
  </Phone>
);

// =========== REPORTS ===========
const ReportsScreen = () => {
  const categories = [
    { icon: "bar_chart",       label: "Sales",       desc: "Revenue, orders, channels & hourly trends", color: C.accent,  bg: C.accentSoft },
    { icon: "restaurant_menu", label: "Product",     desc: "Item & category performance, discounts",    color: C.green,   bg: C.greenSoft },
    { icon: "receipt_long",    label: "EOD Summary", desc: "End-of-day reconciliation & funding",       color: "#7C3AED", bg: "rgba(124,58,237,0.08)" },
    { icon: "how_to_reg",      label: "Check-in",    desc: "Guest arrivals, wait times & party sizes",  color: "#0891B2", bg: "rgba(8,145,178,0.08)" },
    { icon: "event_available", label: "Reservation", desc: "Booking trends, covers & no-show rates",   color: C.orange,  bg: C.orangeSoft },
    { icon: "person",          label: "Customer",    desc: "Guest profiles, frequency & lifetime value",color: C.green,   bg: C.greenSoft },
    { icon: "celebration",     label: "Event",       desc: "Private events, capacity & revenue impact", color: C.red,     bg: C.redSoft },
  ];
  return (
    <Phone label="REPORTS">
      <div style={{ padding: "8px 20px 12px", flexShrink: 0 }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: C.t1 }}>Reports</div>
        <div style={{ fontSize: 11, color: C.t3, marginTop: 2 }}>Select a category to explore</div>
        <div style={{ marginTop: 10, padding: "8px 12px", borderRadius: 10, background: C.hover, border: `1px solid ${C.cardBorder}`, display: "flex", alignItems: "center", gap: 8 }}>
          <Icon name="search" size={16} color={C.t3} />
          <span style={{ fontSize: 12, color: C.t3 }}>Search reports...</span>
        </div>
      </div>
      <div style={{ flex: 1, overflowY: "auto", padding: "4px 16px 16px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          {categories.map((cat, i) => {
            const isLast = i === categories.length - 1;
            const isOdd = categories.length % 2 !== 0;
            return (
              <div key={i} style={{ gridColumn: isLast && isOdd ? "1 / -1" : undefined, background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 14, padding: "16px 14px", cursor: "pointer", boxShadow: C.shadow, position: "relative", overflow: "hidden", display: "flex", flexDirection: "column", gap: 8 }}>
                <div style={{ position: "absolute", top: -16, right: -16, width: 56, height: 56, borderRadius: "50%", background: cat.bg, filter: "blur(14px)", pointerEvents: "none" }} />
                <div style={{ width: 36, height: 36, borderRadius: 10, background: cat.bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Icon name={cat.icon} size={20} color={cat.color} />
                </div>
                <div style={{ fontSize: 13, fontWeight: 700, color: C.t1, lineHeight: 1.2 }}>{cat.label}</div>
                <div style={{ fontSize: 10, color: C.t3, lineHeight: 1.45 }}>{cat.desc}</div>
                <div style={{ position: "absolute", bottom: 10, right: 10, width: 18, height: 18, borderRadius: 6, background: cat.bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Icon name="chevron_right" size={14} color={cat.color} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <BottomNav active={1} />
    </Phone>
  );
};

// =========== MAGHIL AI ===========
const AIScreen = () => (
  <Phone label="MAGHIL AI">
    <div style={{ padding: "8px 20px 12px", flexShrink: 0, borderBottom: `1px solid ${C.divider}` }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 34, height: 34, borderRadius: 10, background: `linear-gradient(135deg, ${C.accent}, ${C.purple})`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, fontWeight: 700, color: "#fff" }}>M</div>
        <div>
          <div style={{ fontSize: 18, fontWeight: 700, color: C.t1 }}>Brisque AI</div>
          <div style={{ fontSize: 10, color: C.green, display: "flex", alignItems: "center", gap: 4 }}>
            <div style={{ width: 5, height: 5, borderRadius: "50%", background: C.green }} />Online
          </div>
        </div>
      </div>
    </div>
    <div style={{ flex: 1, overflowY: "auto", padding: "16px 16px" }}>
      <div style={{ background: `linear-gradient(135deg, ${C.accent}08, ${C.purple}06)`, border: `1px solid ${C.accent}18`, borderRadius: 16, padding: 18, marginBottom: 16 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: C.t1, marginBottom: 6 }}>Hey James!</div>
        <div style={{ fontSize: 12, color: C.t2, lineHeight: 1.6 }}>I can answer questions about your restaurant data. Try asking me about sales trends, menu performance, staff metrics, or anything from your reports.</div>
      </div>
      <div style={{ fontSize: 10, color: C.t3, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Suggested Questions</div>
      {["What were my top 5 selling items last week?", "Which staff member had the most voids today?", "How does DoorDash revenue compare to Uber Eats?", "What's my busiest hour on Saturdays?", "Show me this month's refund rate trend"].map((q, i) => (
        <div key={i} style={{ padding: "10px 14px", borderRadius: 10, background: C.card, border: `1px solid ${C.cardBorder}`, marginBottom: 6, display: "flex", alignItems: "center", gap: 8, boxShadow: C.shadow }}>
          <Icon name="arrow_forward" size={13} color={C.accent} />
          <span style={{ fontSize: 12, color: C.t2 }}>{q}</span>
        </div>
      ))}
      <div style={{ marginTop: 16 }}>
        <div style={{ fontSize: 10, color: C.t3, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Recent</div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
          <div style={{ maxWidth: "80%", padding: "10px 14px", borderRadius: "14px 14px 4px 14px", background: C.accent, fontSize: 12, color: "#fff", lineHeight: 1.5 }}>What was yesterday's top revenue channel?</div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <div style={{ width: 24, height: 24, borderRadius: 6, background: `linear-gradient(135deg, ${C.accent}, ${C.purple})`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, color: "#fff", flexShrink: 0, marginTop: 2 }}>M</div>
          <div style={{ maxWidth: "85%", padding: "12px 14px", borderRadius: "14px 14px 14px 4px", background: C.card, border: `1px solid ${C.cardBorder}`, fontSize: 12, color: C.t2, lineHeight: 1.6, boxShadow: C.shadow }}>
            <span style={{ color: C.t1, fontWeight: 500 }}>Dine-In</span> was your top channel yesterday with <span style={{ color: C.accent, fontWeight: 600 }}>$3,842</span> in revenue (44% of total). Delivery came in second at <span style={{ color: C.green, fontWeight: 600 }}>$2,180</span>.
            <div style={{ marginTop: 8, padding: "8px 10px", borderRadius: 8, background: C.hover, fontSize: 10, color: C.t3, display: "flex", alignItems: "center", gap: 5 }}>
              <Icon name="database" size={11} color={C.t3} />
              Source: mh_summary_daily_sales · Yesterday
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style={{ padding: "8px 16px 20px", flexShrink: 0, borderTop: `1px solid ${C.divider}` }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", borderRadius: 12, background: C.hover, border: `1px solid ${C.cardBorder}` }}>
        <span style={{ flex: 1, fontSize: 13, color: C.t3 }}>Ask about your data...</span>
        <div style={{ width: 32, height: 32, borderRadius: 8, background: C.accent, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Icon name="arrow_upward" size={16} color="#fff" />
        </div>
      </div>
    </div>
    <BottomNav active={2} />
  </Phone>
);

// =========== SUPPORT ===========
const SUPPORT_ITEMS = [
  { icon: "bar_chart",       label: "Reports not loading"   },
  { icon: "credit_card",     label: "Payment discrepancy"   },
  { icon: "manage_accounts", label: "Account & permissions" },
  { icon: "build",           label: "POS integration issue" },
];

const SupportScreen = () => (
  <Phone label="SUPPORT">
    <div style={{ padding: "8px 20px 12px", flexShrink: 0, borderBottom: `1px solid ${C.divider}` }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 34, height: 34, borderRadius: 10, background: C.green, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Icon name="support_agent" size={20} color="#fff" />
        </div>
        <div>
          <div style={{ fontSize: 18, fontWeight: 700, color: C.t1 }}>Support</div>
          <div style={{ fontSize: 10, color: C.green, display: "flex", alignItems: "center", gap: 4 }}>
            <div style={{ width: 5, height: 5, borderRadius: "50%", background: C.green }} />Typically replies in 2 min
          </div>
        </div>
      </div>
    </div>
    <div style={{ flex: 1, overflowY: "auto", padding: "16px 16px" }}>
      <div style={{ background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 14, padding: 16, marginBottom: 16, boxShadow: C.shadow }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: C.t1, marginBottom: 10 }}>Quick Help</div>
        {SUPPORT_ITEMS.map((item, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 0", borderBottom: i < 3 ? `1px solid ${C.divider}` : "none" }}>
            <Icon name={item.icon} size={18} color={C.t3} />
            <span style={{ fontSize: 12, color: C.t2, flex: 1 }}>{item.label}</span>
            <Icon name="chevron_right" size={16} color={C.t3} />
          </div>
        ))}
      </div>
      <div style={{ fontSize: 10, color: C.t3, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Live Chat</div>
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <div style={{ width: 28, height: 28, borderRadius: "50%", background: C.green, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "#fff", flexShrink: 0 }}>R</div>
        <div>
          <div style={{ fontSize: 10, color: C.t3, marginBottom: 3 }}>Rachel · Maghil Support</div>
          <div style={{ padding: "10px 14px", borderRadius: "14px 14px 14px 4px", background: C.card, border: `1px solid ${C.cardBorder}`, fontSize: 12, color: C.t2, lineHeight: 1.5, boxShadow: C.shadow }}>Hi James! Welcome to Maghil Support. How can I help you today?</div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
        <div style={{ maxWidth: "80%", padding: "10px 14px", borderRadius: "14px 14px 4px 14px", background: C.accent, fontSize: 12, color: "#fff", lineHeight: 1.5 }}>Hi! My EOD report is showing a variance of $45. Can you help me figure out where the mismatch is?</div>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <div style={{ width: 28, height: 28, borderRadius: "50%", background: C.green, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "#fff", flexShrink: 0 }}>R</div>
        <div>
          <div style={{ fontSize: 10, color: C.t3, marginBottom: 3 }}>Rachel · Maghil Support</div>
          <div style={{ padding: "10px 14px", borderRadius: "14px 14px 14px 4px", background: C.card, border: `1px solid ${C.cardBorder}`, fontSize: 12, color: C.t2, lineHeight: 1.5, boxShadow: C.shadow }}>Of course! Let me pull up your EOD for today. A $45 variance usually comes from one of three things: pending card settlements, tip adjustments post-close, or a refund processed after the snapshot. Give me one moment to check...</div>
        </div>
      </div>
    </div>
    <div style={{ padding: "8px 16px 20px", flexShrink: 0, borderTop: `1px solid ${C.divider}` }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", borderRadius: 12, background: C.hover, border: `1px solid ${C.cardBorder}` }}>
        <Icon name="attach_file" size={18} color={C.t3} />
        <span style={{ flex: 1, fontSize: 13, color: C.t3 }}>Type a message...</span>
        <div style={{ width: 32, height: 32, borderRadius: 8, background: C.green, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Icon name="arrow_upward" size={16} color="#fff" />
        </div>
      </div>
    </div>
    <BottomNav active={3} />
  </Phone>
);

// =========== MAIN ===========
export default function MobileViews() {
  return (
    <div style={{ minHeight: "100vh", background: "#E8EAF0", padding: "40px 20px", fontFamily: "'DM Sans', -apple-system, sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" rel="stylesheet" />
      <style>{`
        .material-symbols-rounded {
          font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>

      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <div style={{ fontSize: 28, fontWeight: 700, color: "#1A1D2E", letterSpacing: -0.5 }}>Maghil Analytics — Mobile (v6)</div>
        <div style={{ fontSize: 14, color: "#5A6178", marginTop: 6 }}>Brand theme #D23A3B · Light · Material Symbols Rounded</div>
      </div>
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <div style={{ fontSize: 16, fontWeight: 600, color: "#1A1D2E" }}>Main Screens</div>
      </div>
      <div style={{ display: "flex", gap: 28, justifyContent: "center", flexWrap: "wrap", alignItems: "flex-start", marginBottom: 60 }}>
        <SnapshotScreen />
        <ReportsScreen />
        <AIScreen />
        <SupportScreen />
      </div>
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <div style={{ fontSize: 16, fontWeight: 600, color: "#1A1D2E" }}>Snapshot Drill-In Screens</div>
        <div style={{ fontSize: 12, color: "#5A6178", marginTop: 4 }}>Tap any KPI with › arrow for detailed breakdown</div>
      </div>
      <div style={{ display: "flex", gap: 28, justifyContent: "center", flexWrap: "wrap", alignItems: "flex-start" }}>
        <DrillNetSales />
        <DrillOrders />
        <DrillCancelled />
        <DrillStaff />
        <DrillVoids />
        <DrillTips />
      </div>
    </div>
  );
}
